<template>
  <b-form-group class='input-group-sm'>
    <template v-if="required" #label>
        {{label}} <span v-if="required" class="text-danger">*</span>
    </template>
    <GmapAutocomplete ref="gmapAutocomplete" class="form-control-sm form-control g_autocomplete" @keydown="handleKeyDown" @place_changed="addMarker" />
    <div v-if="errors.addressAll" class="d-block invalid-feedback">{{errors.addressAll[0]}}</div>
    <div class="row" style="padding-top: 10px;">
      <div class="col-md-6">
        <template>
            Vĩ độ <span v-if="required" class="text-danger">*</span>
        </template>
        <b-form-input disabled class='form-control-sm g_input' v-model="addressAll.lat" type="text"></b-form-input>
        <div v-if="errors.lat" class="d-block invalid-feedback">{{errors.lat[0]}}</div>
      </div>
      <div class="col-md-6">
        <template>
            Kinh độ <span v-if="required" class="text-danger">*</span>
        </template>
        <b-form-input disabled class='form-control-sm g_input' v-model="addressAll.long" type="text"></b-form-input>
        <div v-if="errors.long" class="d-block invalid-feedback">{{errors.long[0]}}</div>
      </div>
    </div>
    <GmapMap
      :center="center"
      :zoom="12"
      style="width: 100%; height: 400px; margin-top: 20px"
    >
    
      <GmapMarker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        @click="center = m.position"
      />
    </GmapMap>
  </b-form-group>
</template>
<script>
export default {
  props: {
      model: Object,
      attribute: {
          type: String,
          default: 'addressAll'
      },
      label: String,
      required: Boolean,
      errors: Object,
  },
  data() {
    return {
      defaultCenter: { lat: 15.8801, lng: 108.3380 },
      center: {},
      currentPlace: null,
      markers: [],
      defalutAddress: {
        lat: null,
        long: null,
        address: null,
      },
      addressAll: {
        lat: null,
        long: null,
        address: null,
      },
      maker: {},
      defalutMaker: {},
    };
  },
  watch: {
   
  },
  methods: {
    addMarker(place) {
      this.currentPlace = place;
      if (this.currentPlace) {
        this.marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };
        this.addressAll.address = place.adr_address;
        this.markers.push({ position: this.marker });
        this.addressAll.lat = this.marker.lat;
        this.addressAll.long = this.marker.lng;
        this.center = this.marker;
        this.currentPlace = null;
        this.model[this.attribute] = this.addressAll;
      }
    },
    clearData() {
      // Clear all data
      this.marker = {...this.defalutMaker};
      this.addressAll = {...this.defalutAddress};
      this.currentPlace = null;
      this.markers = [];
      this.model[this.attribute] = {...this.defalutAddress};
    },

    handleKeyDown(event) {
      if (event.key === 'Backspace') {
        this.clearData();
      }
    },
    loadSelected() {
      if (this.model[this.attribute]) {
        if(Object.keys(this.model[this.attribute]).length !== 0){
          this.markers.forEach(marker => {
                marker.setMap(null);
            });
          this.markers = [];
          this.addressAll = this.model[this.attribute];
          this.$refs.gmapAutocomplete.$refs.input.value = this.addressAll.address;
          this.marker = {
            lat: parseFloat(this.addressAll.lat),
            lng: parseFloat(this.addressAll.long),
          };
          console.log(this.markers);
          this.markers.push({ position: this.marker });
          this.center = this.marker;
        }
      }     
    }
  },
  mounted() {
    this.loadSelected();
  }
};
</script>
<style>
.pac-target-input {
  padding: 10px;
  width: 20%;
}
.pac-container {
  z-index: 9999;
}
.g_autocomplete {
  width: 100% !important;
}
</style>